"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStore = exports.keyStores = exports.originalKeyStores = void 0;
var store = new Map();
exports.originalKeyStores = new Map();
exports.keyStores = new Map();
exports.setStore = function (target, options) {
    var key = options.key, rest = __rest(options, ["key"]);
    var storeKey = target.constructor;
    var targetStore = store.has(storeKey) ? store.get(storeKey) : new Map();
    var value = targetStore.has(key) ? targetStore.get(key) : {};
    value = __assign(__assign({}, value), rest);
    targetStore.set(key, value);
    store.set(storeKey, targetStore);
};
exports.default = store;
//# sourceMappingURL=store.js.map